import About from "./components/AboutMe";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import GitHubContributions from "./components/GitHubContributions";
import { Landing } from "./components/Landing";
import { Navbar } from "./components/Navbar";
import Projects from "./components/Projects";
import Skills from "./components/Skills";

function App() {
  return (
    <div className="bg-gradient-to-r from-slate-950 to-black">
      <section id="home">
        <Navbar />
        <Landing />
        <About />
        <GitHubContributions />
        <Projects />
        <Skills />
        <Contact />
        <Footer />
      </section>
    </div>
  );
}

export default App;
